export const privacyCookieModalSeenKey = 'privacyCookieModalSeen';
export const allowedCountriesWithNikePrivacy = [];
